import React from 'react'
import { Helmet } from 'react-helmet-async'
import cx from 'classnames'
import { observer } from 'mobx-react'
import styles from './Welcome.m.sass'

export default observer(function Welcome({ rootStore, router }) {
  return (
    <div className={cx(styles.root)}>
      <Helmet title="Welcome to Worklayer HQ!" />
      <h1 className={styles.title}>Welcome to Worklayer HQ</h1>
      <div className={styles.content}>
        <p>Use the navigation bar on the left to look around.</p>
      </div>
    </div>
  )
})
